import { PageHeader } from '@/shared/components/PageHeader';
import { ClipboardList } from 'lucide-react';
import TaskTypesStep from '../components/TaskTypesStep';

export default function TaskTypesPage() {
  return (
    <>
      <PageHeader
        title="Task Types"
        subtitle="Configure available task types and form assignments"
        icon={<ClipboardList className="size-7 text-primary" />}
      />

      <TaskTypesStep />
    </>
  );
}
